Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingDetails3032683875",
  {"root":"OfferingDetails3032683875--root"},
  "",
  2,
  "OfferingDetails3032683875"
);

